var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75635 7.69458C7.55916 7.89014 7.29175 8 7.01292 8C6.7341 8 6.46668 7.89014 6.26949 7.69458L0.321018 1.79348C0.220587 1.69725 0.140479 1.58214 0.08537 1.45487C0.0302606 1.32761 0.00125297 1.19072 3.97018e-05 1.05222C-0.00117356 0.913706 0.0254321 0.776345 0.0783037 0.648146C0.131175 0.519946 0.209254 0.403476 0.307985 0.305532C0.406715 0.207587 0.52412 0.13013 0.653348 0.0776796C0.782577 0.0252291 0.921041 -0.00116422 1.06066 3.93863e-05C1.20028 0.00124299 1.33826 0.0300196 1.46655 0.0846901C1.59484 0.139361 1.71087 0.21883 1.80787 0.318461L7.01292 5.48206L12.218 0.318461C12.4163 0.128443 12.6819 0.0232993 12.9576 0.0256761C13.2333 0.0280528 13.4971 0.13776 13.692 0.331168C13.887 0.524577 13.9976 0.786212 14 1.05972C14.0024 1.33323 13.8964 1.59674 13.7048 1.79348L7.75635 7.69458Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.83905df3856f674ed48c9b66112ef49e.svg";
export { ForwardRef as ReactComponent };